import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type AgentKebabInteractionOption =
  | "delete"
  | "rename"
  | "change_owner"
  | "share"
  | "move";

export function useEmitAgentKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: AgentKebabInteractionOption, agentId?: string) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.AgentKebab,
        optionSelected,
        customTrackingFields: {
          agent_id: agentId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
